/**
 * Environment & Base API Configuration Utility
 */

export const getApiBaseUrl = () => {
  const envUrl = process.env.REACT_APP_API_URL;
  const url = (envUrl !== undefined ? envUrl : "/api").replace(/\/+$/, "");
  return url;
};

export const getHubUrl = (hubName = "workflow") => {
  const baseUrl = getApiBaseUrl();
  if (baseUrl.startsWith("http")) {
    return `${baseUrl}/hubs/${hubName}`;
  }
  if (baseUrl) {
    const cleanBase = baseUrl.startsWith("/") ? baseUrl : `/${baseUrl}`;
    return `${cleanBase}/hubs/${hubName}`;
  }
  return `/hubs/${hubName}`;
};

/**
 * Normalizes request configuration before dispatch:
 * - Strips duplicate /api prefix when baseURL already includes /api
 * - Cleans malformed prefixes like undefined/ or repeated /api/api
 * - Attaches Bearer authentication token from sessionStorage if present
 */
export const normalizeRequestConfig = (config) => {
  if (!config) return config;
  const result = { ...config };

  const token = typeof sessionStorage !== "undefined" ? sessionStorage.getItem("token") : null;
  if (token) {
    result.headers = { ...result.headers, Authorization: `Bearer ${token}` };
  }

  if (typeof result.url !== "string") {
    return result;
  }

  let url = result.url;

  if (url.startsWith("undefined/")) {
    url = "/" + url.slice("undefined/".length);
  }

  while (url.startsWith("/api/api")) {
    url = url.slice(4);
  }

  const baseURL = result.baseURL || "";
  const baseEndsWithApi = baseURL === "/api" || baseURL.endsWith("/api");

  if (baseEndsWithApi) {
    if (url === "/api") {
      url = "";
    } else if (url.startsWith("/api/")) {
      url = url.slice(4);
    }
  }

  result.url = url;
  return result;
};

